import styled from 'styled-components/macro';
import { definitionLabel } from 'styles/base-classes';

export const Label = styled('p')`
  ${definitionLabel};
  font-size: 11px;
  margin: 0 0 10px 0;
`;

export const IconAndTextWrapper = styled('div')<any>`
  display: flex;
  align-items: center;
  cursor: default;
  ${({ isSelected, theme }): string =>
    isSelected
      ? `
        path {
            stroke: ${theme.AccentGreen};
            fill: ${theme.AccentGreen};
        }   
    `
      : ''}
`;
